module.exports = __webpack_public_path__ + "static/media/coach-gen.da5ff682.png";